import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../choose-menu.css';

/**
 * SelectItems
 * Step component for selecting multiple food items with prices.
 * Props:
 *   items: Array<{ name: string, price: number }>
 *   selectedItems: Array<{ name: string, quantity: number }>
 *   onChange: (selected: Array<{ name: string, quantity: number }>) => void
 */
const SelectItems = ({ items, selectedItems, onChange }) => {
  // selectedItems: [{ name, quantity }]
  const getQuantity = (itemName) => {
    const found = selectedItems.find((i) => i.name === itemName);
    return found ? found.quantity : 0;
  };

  const handleAdd = (itemName) => {
    const found = selectedItems.find((i) => i.name === itemName);
    if (found) {
      onChange(selectedItems.map((i) => i.name === itemName ? { ...i, quantity: i.quantity + 1 } : i));
    } else {
      onChange([...selectedItems, { name: itemName, quantity: 1 }]);
    }
  };

  const handleRemove = (itemName) => {
    const found = selectedItems.find((i) => i.name === itemName);
    if (found && found.quantity > 1) {
      onChange(selectedItems.map((i) => i.name === itemName ? { ...i, quantity: i.quantity - 1 } : i));
    } else {
      onChange(selectedItems.filter((i) => i.name !== itemName));
    }
  };

  // Group items by category
  const grouped = items.reduce((acc, item) => {
    if (!acc[item.category]) acc[item.category] = [];
    acc[item.category].push(item);
    return acc;
  }, {});

  const categories = Object.keys(grouped);
  // Support multiple open categories
  const [openCategories, setOpenCategories] = useState([categories[0]]);

  const handleCategoryToggle = (cat) => {
    setOpenCategories((prev) =>
      prev.includes(cat)
        ? prev.filter((c) => c !== cat)
        : [...prev, cat]
    );
  };

  return (
    <div className="food-item-selector">
      {categories.map((cat, idx) => {
        const isOpen = openCategories.includes(cat);
        return (
          <div key={cat} className={`food-category-group${isOpen ? ' open' : ''}`}>
            <div
              className="food-category-header"
              onClick={() => handleCategoryToggle(cat)}
              style={{cursor: 'pointer', fontWeight: 600, fontSize: '1.1rem', background: '#f7f7f7', padding: '10px 16px', borderRadius: 6, marginBottom: 4,}}
            >
              {cat}
              <span style={{float: 'right', fontWeight: 400, color: '#eb6c20'}}>{isOpen ? '▲' : '▼'}</span>
            </div>
            <div className="food-category-content">
              <div className="food-item-list food-item-list-row" style={{marginBottom: 16, display: isOpen ? undefined : 'none'}}>
                {grouped[cat].map((item) => {
                  const quantity = getQuantity(item.name);
                  return (
                    <div key={item.name} className="food-item-row">
                      {/* {item.image && (
                        <img src={item.image} alt={item.name} style={{width: 38, height: 38, objectFit: 'cover', borderRadius: 6, marginRight: 12}} />
                      )} */}
                      <span className="food-item-name">{item.name}</span>
                      <span className="food-item-price">₹{item.price}</span>
                      {quantity === 0 ? (
                        <button
                          className="food-item-action-btn add"
                          onClick={() => handleAdd(item.name)}
                          type="button"
                        >
                          Add
                        </button>
                      ) : (
                        <div className="food-item-qty-controls">
                          <button
                            className="food-item-qty-btn"
                            onClick={() => handleRemove(item.name)}
                            type="button"
                          >
                            -
                          </button>
                          <span className="food-item-qty-value">{quantity}</span>
                          <button
                            className="food-item-qty-btn"
                            onClick={() => handleAdd(item.name)}
                            type="button"
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

SelectItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  selectedItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectItems;
